import { Lock } from 'lucide-react'

export type MedalTier = 'bronze' | 'silver' | 'gold'

const TIER_COLORS: Record<MedalTier, { base: string; light: string; dark: string }> = {
  bronze: { base: '#C9803B', light: '#E8B27A', dark: '#8A5320' },
  silver: { base: '#C5CDD8', light: '#F1F5F9', dark: '#8C99A8' },
  gold: { base: '#F5C542', light: '#FFF3C4', dark: '#8A6914' },
}

// Inline SVG medal: crisp at 24-64px and themeable, unlike a raster asset.
export function MedalIcon({ tier, size = 40, locked = false }: {
  tier: MedalTier
  size?: number
  locked?: boolean
}) {
  const c = TIER_COLORS[tier]
  const gradId = `medal-${tier}`

  if (locked) {
    return (
      <span
        style={{
          width: size,
          height: size,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '50%',
          background: 'var(--fill-soft)',
          border: '1.5px dashed var(--border-default)',
          color: 'var(--text-muted)',
          flex: 'none',
        }}
      >
        <Lock size={Math.max(14, size * 0.36)} />
      </span>
    )
  }

  return (
    <svg width={size} height={size} viewBox="0 0 48 48" role="img" aria-label={`Medalla ${tier}`} style={{ flex: 'none' }}>
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor={c.light} />
          <stop offset="50%" stopColor={c.base} />
          <stop offset="100%" stopColor={c.dark} />
        </linearGradient>
      </defs>
      {/* ribbon */}
      <path d="M17 2 L24 14 L31 2 L38 6 L28 20 H20 L10 6 Z" fill={c.dark} opacity="0.9" />
      {/* medal disc */}
      <circle cx="24" cy="31" r="14.5" fill={`url(#${gradId})`} stroke={c.dark} strokeWidth="1.5" />
      <circle cx="24" cy="31" r="10.5" fill="none" stroke={c.light} strokeWidth="1" opacity="0.7" />
      {/* padel ball seam in the centre */}
      <circle cx="24" cy="31" r="6.5" fill={c.light} opacity="0.35" />
      <path d="M19 26.5 C22 29 22 33 19 35.5 M29 26.5 C26 29 26 33 29 35.5" stroke={c.dark} strokeWidth="1.3" fill="none" strokeLinecap="round" />
    </svg>
  )
}
